export const ROUTES = {
  LOGIN: '/login',
  DASHBOARD: '/',

  SHOP: {
    LIST: '/shop/items',
    CREATE: '/shop/items/create',
    EDIT: (id: string | number = ':id') => `/shop/items/${id}/edit`,
    DETAIL: (id: string | number = ':id') => `/shop/items/${id}`,
  },

  FAN_CLUB: {
    LIST: '/fan-clubs',
    CREATE: '/fan-clubs/create',
    EDIT: (id: string | number = ':id') => `/fan-clubs/${id}/edit`,
  },

  MATCH: {
    LIST: '/matches',
    CREATE: '/matches/create',
    EDIT: (id: string | number = ':id') => `/matches/${id}/edit`,
    DETAIL: (id: string | number = ':id') => `/matches/${id}`,
    LIST_OF_WINNER: (id: string | number = ':id') => `/matches/list-of-winners/${id}`,
    FINISHED: (id: string | number = ':id') => `/matches/${id}/finished`,
  },

  TEAM: {
    LIST: '/teams',
    CREATE: '/teams/create',
    EDIT: (id: string | number = ':id') => `/teams/${id}/edit`,
    DETAIL: (id: string | number = ':id') => `/teams/${id}`,
  },

  TOURNAMENT: {
    LIST: '/tournaments',
    CREATE: '/tournaments/create',
    EDIT: (id: string | number = ':id') => `/tournaments/${id}/edit`,
    DETAIL: (id: string | number = ':id') => `/tournaments/${id}`,
  },

  USER_PROFILE: '/player',

  GAMES: {
    LIST: '/games',
    CREATE: '/games/create',
    EDIT: (id: string | number = ':id') => `/games/${id}/edit`,
  },

  SETTING: {
    FUNCTION: '/setting/function',
    FEATURE: '/setting/feature',
    CACHE_SYSTEM: '/setting/cache-system',
    USER_MANAGEMENT: '/setting/user-management',
  },
  REWARD: {
    LIST: '/reward',
    CREATE: '/reward/create',
    EDIT: (id: string | number = ':id') => `/reward/${id}/edit`,
  },
  CONFIG: {
    PACKAGE: {
      LIST: '/config/package',
      CREATE: '/config/package/create',
      EDIT: (id: string | number = ':id') => `/config/package/${id}/edit`,
    },
    SHARE_LINK: {
      LIST: '/config/share-link',
      CREATE: '/config/share-link/create',
      EDIT: (id: string | number = ':id') => `/config/share-link/${id}/edit`,
    },
    BACKGROUND: {
      LIST: '/config/background',
      CREATE: '/config/background/create',
      EDIT: (id: string | number = ':id') => `/config/background/${id}/edit`,
    },
    RULES: {
      LIST: '/config/rules',
      CREATE: '/config/rules/create',
      EDIT: (id: string | number = ':id') => `/config/rules/${id}/edit`,
    },
  },
  LOG: {
    PLAYER_TURNS: '/logs/player-turns',
    REWARD: '/logs/reward',
    QUIZ: '/logs/quiz',
    PREDICTION: '/logs/prediction',
    PLAYER_POINT: '/logs/player-point',
  },

  LEADER_BOARD_PLAYER: {
    LIST: '/leaderboards/player',
    CREATE: '/leaderboards/player/create',
  },

  LEADER_BOARD_FANCLUB: {
    LIST: '/leaderboards/fanclub',
    CREATE: '/leaderboards/fanclub/create',
  },

  DEMO: '/demo',
  NOT_FOUND: '/not-found',
  FORBIDDEN: '/403',
};
